import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const Tooltipconversion = () => (
  <Tooltip title="convert the data types before moving to General EDA Page">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default Tooltipconversion;